<div class="batch-header flex justify-space-between">
    <div class="admin-header">
        <h4 class="heading">Archived Batch Alert</h4>
    </div>
</div>

<section class="error-wrapper" *ngIf="batchAlertService.archivedBatchAlertErrMsg">
    <f-alert variant="error">
        <p>
            There was problem loading the data. <a  href="javascript:void('0')" (click)="batchAlertService.getDataforArchivedAlert(batchAlertService.clientId)"class="btn-alert">Try again.</a>
        </p>
    </f-alert>

</section>

<div class="current-batch-table">
    <app-alight-table class="current-table" [dataSource]="batchAlertService.archivedBatchAlertData" [totalRecords]="totalRecords" [gridColumns]="batchAlertService.currentColumns"
    [tableName]="'ArchivedTable'" [rowPerPage]="10" (rowSelection)="rowSelection($event)"
    [isShowButtons]="false"></app-alight-table>
</div>